<template>
    <slot
        :confirming="confirming"
        :askToConfirm="askToConfirm"
        :cancel="cancel"
    />
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = withDefaults(defineProps<{ confirm?: boolean }>(), {
    confirm: true,
});

/**
 * Whether this control is asking its moderator to confirm a denial.
 *
 * The flag is the whole component — it renders nothing of its own. The control, its form and every
 * button stay in the Blade template that renders the queue and reach this through the scoped slot,
 * so the CSRF token and the moderation route never move into JavaScript, and the deny button
 * degrades to the immediate submit it has always been when the bundle has not loaded.
 */
const confirming = ref(false);

/**
 * Ask this control's moderator to confirm, unless there is nothing to confirm.
 *
 * The handler and not a `.prevent` modifier decides, because `confirm` false has to let the click
 * through to the submit it was always going to be.
 */
function askToConfirm(event: Event): void {
    if (!props.confirm) {
        return;
    }

    event.preventDefault();
    confirming.value = true;
}

function cancel(): void {
    confirming.value = false;
}
</script>
